import React, {useState} from 'react'
import {connect} from 'react-redux'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {makeStyles} from "@material-ui/core";
import VS from "constants/ValidationShema";
import TextInput from "components/TextInput";
import PropTypes from 'prop-types'
import DoubleButton from "../../../popup/components/DoubleButton";

const useStyle = makeStyles(theme => ({
    margin: {
        marginBottom: theme.spacing(2)
    },
    disabledEmpty: {
        fontStyle: 'italic'
    },
    disabled: {
        '& textarea': {
            color: theme.palette.text.primary
        }
    },
    textField: {
        wordBreak: "break-word",
        whiteSpace: 'pre-line',
        marginBottom: theme.spacing(2)
    }
}));

export const createEditNoticeReferenceNumberFile = (demandId, identity, noticeReferenceNumber) => ({demandId, identity, noticeReferenceNumber})

function AddNoticeReferenceNumberPopup(
    {
        editNoticeReferenceNumberFile,
        onUpdated,
        onClose,
        service,
        formSubmit,
    }) {

    const classes = useStyle();
    const formId = useId();
    const [working, setWorking] = useState(false);

    const handleSubmit = () => formSubmit[formId]();

    const onSubmit = ({noticeReferenceNumber}) => {
        setWorking(true);
        service.updateNoticeReferenceNumber(editNoticeReferenceNumberFile.demandId,
                                            editNoticeReferenceNumberFile.identity,
                                            noticeReferenceNumber)
            .then(onUpdated)
            .finally(()=> setWorking(false))
    }

    return (
        <Dialog
            title={Tr("enter_notice_reference_number")}
            maxWidth={'sm'}
            open={true}
            onClose={onClose}
        >

            <Form
                initialValues={{
                    noticeReferenceNumber: editNoticeReferenceNumberFile.noticeReferenceNumber,
                }}
                validationSchema={Yup.object().shape({
                    noticeReferenceNumber: VS.string(),
                })}
                onSubmit={onSubmit}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>

                        <TextInput
                            id='noticeReferenceNumber'
                            formikProps={formikProps}
                            label={Tr('notice_reference_number')}
                            disabled={working}
                        />

                        <div className={classes.actions}>
                            <DoubleButton
                                justify='flex-end'
                                labelFirst={Tr('cancel')}
                                labelSecond={Tr('confirm2')}
                                onClickFirst={onClose}
                                onClickSecond={handleSubmit}
                                disabledFirst={working}
                                disabledSecond={working}
                            />
                        </div>

                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

AddNoticeReferenceNumberPopup.propTypes = {
    editNoticeReferenceNumberFile: PropTypes.shape({
        demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        identity: PropTypes.oneOfType([PropTypes.number, PropTypes.object]).isRequired,
        noticeReferenceNumber: PropTypes.string
    }).isRequired,
    onUpdated: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    service: PropTypes.shape({
        updateDescription: PropTypes.func.isRequired
    })
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(AddNoticeReferenceNumberPopup);